import axiosCreator from '../http-common';
import { smsService, emailService, printService } from '../service';
import { getToken } from '../service/authentication';


const smsTemplateAll_REQ = () => {
  return {
    type: 'SMS_TEMPLATE_ALL_REQ'
  };
};

const smsTemplateAll_OK = smsTemplateList => {
  return {
    type: 'SMS_TEMPLATE_ALL_OK',
    smsTemplateList
  };
};

const smsTemplateAll_X = error => {
  return {
    type: 'SMS_TEMPLATE_ALL_X',
    error
  };
};

const smsTemplateAll_RESET = () => {
  return {
    type: 'SMS_TEMPLATE_ALL_RESET',
    smsTemplateList: [],
  };
};

const smsTemplateSave_REQ = () => {
  return {
    type: 'SMS_TEMPLATE_SAVE_REQ'
  };
};

const smsTemplateSave_OK = smsTemplate => {
  return {
    type: 'SMS_TEMPLATE_SAVE_OK',
    smsTemplate,
  };
};
const smsTemplateSave_X = () => {
  return {
    type: 'SMS_TEMPLATE_SAVE_X'
  };
};

const smsTemplateRemove_REQ = () => {
  return {
    type: 'SMS_TEMPLATE_REMOVE_REQ'
  };
};

const smsTemplateRemove_OK = (smsTemplateId) => {
  return {
    type: 'SMS_TEMPLATE_REMOVE_OK',
    smsTemplateId
  };
};

const smsTemplateRemove_X = () => {
  return {
    type: 'SMS_TEMPLATE_REMOVE_X'
  };
};

const smsTemplate_REQ = id => {
  return {
    type: 'SMS_TEMPLATE_REQ',
    id
  };
};

const smsTemplate_OK = smsTemplate => {
  return {
    type: 'SMS_TEMPLATE_OK',
    smsTemplate
  };
};

const smsTemplate_X = error => {
  return {
    type: 'SMS_TEMPLATE_X',
    error
  };
};

const emailTemplateAll_REQ = () => {
  return {
    type: 'EMAIL_TEMPLATE_ALL_REQ'
  };
};

const emailTemplateAll_OK = emailTemplateList => {
  return {
    type: 'EMAIL_TEMPLATE_ALL_OK',
    emailTemplateList
  };
};

const emailTemplateAll_X = error => {
  return {
    type: 'EMAIL_TEMPLATE_ALL_X',
    error
  };
};

const emailTemplate_REQ = id => {
  return {
    type: 'EMAIL_TEMPLATE_REQ',
    id
  };
};

const emailTemplate_OK = emailTemplate => {
  return {
    type: 'EMAIL_TEMPLATE_OK',
    emailTemplate
  };
};

const emailTemplate_X = error => {
  return {
    type: 'EMAIL_TEMPLATE_X',
    error
  };
};

const emailTemplateRemove_REQ = () => {
  return {
    type: 'EMAIL_TEMPLATE_REMOVE_REQ'
  };
};

const emailTemplateRemove_OK = (emailTemplateId) => {
  return {
    type: 'EMAIL_TEMPLATE_REMOVE_OK',
    emailTemplateId
  };
};

const emailTemplateRemove_X = () => {
  return {
    type: 'EMAIL_TEMPLATE_REMOVE_X'
  };
};

const emailTemplateAll_RESET = () => {
  return {
    type: 'EMAIL_TEMPLATE_ALL_RESET',
    emailTemplateList: [],
  };
};

const emailTemplateSave_REQ = () => {
  return {
    type: 'EMAIL_TEMPLATE_SAVE_REQ'
  };
};

const emailTemplateSave_OK = emailTemplate => {
  return {
    type: 'EMAIL_TEMPLATE_SAVE_OK',
    emailTemplate,
  };
};
const emailTemplateSave_X = () => {
  return {
    type: 'EMAIL_TEMPLATE_SAVE_X'
  };
};

const templatesForm_UPDATE = formData => {
  return {
    type: 'TEMPLATES_FORM_UPDATE',
    formData
  };
};

const ongoing_REQ = () => {
  return {
    type: 'TEMPLATE_ONGOING_REQ'
  };
};

const ongoing_OK = (ongoing) => {
  return {
    type: 'TEMPLATE_ONGOING_OK',
    ongoing
  };
};

const ongoing_X = () => {
  return {
    type: 'TEMPLATE_ONGOING_X'
  };
};

const updateTemplatesForm = (dispatch, formData) => {
  dispatch(templatesForm_UPDATE(formData));
};

const fetchSMStemplates = async (dispatch, chainId, siteId) => {
  try {
    dispatch(smsTemplateAll_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response  = await axios.get(`/api/smstemplates?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'loading smstemplates' };
    if (response.status !== 200) throw new Error(error);
    const smsTemplateList = response.data;
    dispatch(smsTemplateAll_OK(smsTemplateList));
  } catch (err) {
    dispatch(smsTemplateAll_X(err));
  }
};

const saveSMStemplate = async (dispatch, chainId, siteId, data) => {
  try {
    dispatch(smsTemplateSave_REQ());
    const { id } = data;
    const smsTemplate = id
      ? await smsService.update(id, data)
      : await smsService.create(data, chainId, siteId);
    dispatch(smsTemplateSave_OK(smsTemplate));
    return smsTemplate;
  } catch (err) {
    dispatch(smsTemplateSave_X());
    return false;
  }
};

const removeSMSTemplate = async (dispatch, id) => {
  try {
    dispatch(smsTemplateRemove_REQ());
    const result = await smsService.remove(id);
    dispatch(smsTemplateRemove_OK(id));
    return result;
  } catch (err) {
    console.log(err);
    dispatch(smsTemplateRemove_X());
    return false;
  }
};

const saveEmailTemplate = async (dispatch, chainId, siteId, data) => {
  try {
    dispatch(emailTemplateSave_REQ());
    const { id } = data;
    const emailTemplate = id
      ? await emailService.update(id, data)
      : await emailService.create(data, chainId, siteId);
    dispatch(emailTemplateSave_OK(emailTemplate));
    return emailTemplate;
  } catch (err) {
    console.log(err);
    dispatch(emailTemplateSave_X());
    return false;
  }
};

const removeEmailTemplate = async (dispatch, id) => {
  try {
    dispatch(emailTemplateRemove_REQ());
    const result = await emailService.remove(id);
    dispatch(emailTemplateRemove_OK(id));
    return result;
  } catch (err) {
    console.log(err);
    dispatch(emailTemplateRemove_X());
    return false;
  }
};

const savePrintTemplate = async (dispatch, chainId, siteId, data) => {
  try {
    dispatch(printTemplateSave_REQ());
    const { id } = data;
    const printTemplate = id
      ? await printService.update(id, data)
      : await printService.create(data, chainId, siteId);
    dispatch(printTemplateSave_OK(printTemplate));
    return printTemplate;
  } catch (err) {
    console.log(err);
    dispatch(printTemplateSave_X());
    return false;
  }
};

const removePrintTemplate = async (dispatch, id) => {
  try {
    dispatch(printTemplateRemove_REQ());
    const result = await printService.remove(id);
    dispatch(printTemplateRemove_OK(id));
    return result;
  } catch (err) {
    console.log(err);
    dispatch(printTemplateRemove_X());
    return false;
  }
};

const fetchSMStemplatesById = async (dispatch, id) => {
  try {
    dispatch(smsTemplate_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response  = await axios.get(`/api/smstemplates/${id}`);
    const error = { error: 'loading smstemplate' };
    if (response.status !== 200) throw new Error(error);
    const smsTemplate = response.data;
    dispatch(smsTemplate_OK(smsTemplate));
  } catch (err) {
    dispatch(smsTemplate_X(err));
  }
};

const fetchEmailTemplates = async (dispatch, chainId, siteId) => {
  try {
    dispatch(emailTemplateAll_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response  = await axios.get(`/api/emailtemplates?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'loading emailtemplates' };
    if (response.status !== 200) throw new Error(error);
    const emailTemplateList = response.data;
    dispatch(emailTemplateAll_OK(emailTemplateList));
  } catch (err) {
    dispatch(emailTemplateAll_X(err));
  }
};

const fetchEmailTemplatesById = async (dispatch, id) => {
  try {
    dispatch(emailTemplate_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response  = await axios.get(`/api/emailtemplates/${id}`);
    const error = { error: 'loading emailtemplate' };
    if (response.status !== 200) throw new Error(error);
    const emailTemplate = response.data;
    dispatch(emailTemplate_OK(emailTemplate));
  } catch (err) {
    dispatch(emailTemplate_X(err));
  }
};

const setOngoing = async (dispatch, id, chainId, siteId) => {
  try {
    dispatch(ongoing_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response = await axios.post(`/api/smstemplates/${id}/ongoing?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'setting template ongoing failed' };
    if (response.status !== 200) throw new Error(error);
    dispatch(ongoing_OK(response.data));
    return response.data;
  } catch (err) {
    dispatch(ongoing_X(err));
  }
};

const setOngoingEmail = async (dispatch, id, chainId, siteId) => {
  try {
    dispatch(ongoing_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response = await axios.post(`/api/emailtemplates/${id}/ongoing?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'setting template ongoing failed' };
    if (response.status !== 200) throw new Error(error);
    dispatch(ongoing_OK(response.data));
    return response.data;
  } catch (err) {
    dispatch(ongoing_X(err));
  }
};

const fetchPrintTemplates = async (dispatch, chainId, siteId) => {
  try {
    dispatch(printTemplateAll_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response  = await axios.get(`/api/printtemplates?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'loading printtemplates' };
    if (response.status !== 200) throw new Error(error);
    const printTemplateList = response.data;
    dispatch(printTemplateAll_OK(printTemplateList));
  } catch (err) {
    dispatch(printTemplateAll_X(err));
  }
};

const printTemplateAll_REQ = () => {
  return {
    type: 'PRINT_TEMPLATE_ALL_REQ'
  };
};

const printTemplateAll_OK = printTemplateList => {
  return {
    type: 'PRINT_TEMPLATE_ALL_OK',
    printTemplateList
  };
};

const printTemplateAll_X = error => {
  return {
    type: 'PRINT_TEMPLATE_ALL_X',
    error
  };
};

const printTemplateSave_REQ = () => {
  return {
    type: 'PRINT_TEMPLATE_SAVE_REQ'
  };
};

const printTemplateSave_OK = printTemplate => {
  return {
    type: 'PRINT_TEMPLATE_SAVE_OK',
    printTemplate,
  };
};
const printTemplateSave_X = () => {
  return {
    type: 'PRINT_TEMPLATE_SAVE_X'
  };
};

const printTemplateRemove_REQ = () => {
  return {
    type: 'PRINT_TEMPLATE_REMOVE_REQ'
  };
};

const printTemplateRemove_OK = (printTemplateId) => {
  return {
    type: 'PRINT_TEMPLATE_REMOVE_OK',
    printTemplateId
  };
};

const printTemplateRemove_X = () => {
  return {
    type: 'PRINT_TEMPLATE_REMOVE_X'
  };
};

const setOngoingPrint = async (dispatch, id, chainId, siteId) => {
  try {
    dispatch(ongoing_REQ());
    const token = await getToken();
    const axios = await axiosCreator(token, true);
    const response = await axios.post(`/api/printtemplates/${id}/ongoing?chainId=${chainId}&siteId=${siteId}`);
    const error = { error: 'setting template ongoing failed' };
    if (response.status !== 200) throw new Error(error);
    dispatch(ongoing_OK(response.data));
    return response.data;
  } catch (err) {
    dispatch(ongoing_X(err));
  }
};

const printTemplateAll_RESET = () => {
  return {
    type: 'PRINT_TEMPLATE_ALL_RESET',
    printTemplateList: [],
  };
};

export {
  fetchSMStemplates,
  saveSMStemplate,
  removeSMSTemplate,
  fetchSMStemplatesById,
  fetchEmailTemplates,
  saveEmailTemplate,
  removeEmailTemplate,
  fetchEmailTemplatesById,
  fetchPrintTemplates,
  savePrintTemplate,
  removePrintTemplate,
  updateTemplatesForm,
  setOngoing,
  setOngoingEmail,
  setOngoingPrint,
  smsTemplateAll_RESET,
  emailTemplateAll_RESET,
  printTemplateAll_RESET
};
